<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-text">
      <SearchHighlightedText :text="value" :search-term="searchTerm" />
    </div>
  </div>
</template>

<script>
/**
 * The unselected email cell.
 *
 * `EmailFieldType` used to point this slot at `FunctionalGridViewFieldURL`,
 * which was harmless while the two rendered the same thing and stopped being so
 * once the URL cell grew a favicon.
 *
 * `getFaviconUrl` does refuse a `mailto:` scheme, but a grid cell holds a bare
 * address, so nothing was refused: `someone@example.com` has no scheme,
 * `ensureUrlProtocol` makes it `https://someone@example.com`, and the URL parser
 * reads `example.com` as the hostname. Every email cell therefore fetched the
 * favicon of the address's DOMAIN and drew it beside the address -- google's
 * icon next to a gmail address, which says nothing about the contact -- and
 * leaked one request per visible row to a third party.
 *
 * Matches `GridViewFieldEmail`, the selected-cell component, which renders
 * through `grid-field-text`; and `FunctionalGridViewFieldPhoneNumber`, which is
 * the same cell for the same reason.
 */
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldEmail',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
